import { EBehavior } from '../../../enums/EBehavior';
import { prepareMultiplyCheckboxGroupItemChangeModel } from './prepareMultiplyCheckboxGroupItemChangeModel';
import { prepareSingleCheckboxGroupItemChangeModel } from './prepareSingleCheckboxGroupItemChangeModel';
import { prepareSingleInOneGroupCheckboxGroupItemChangeModel } from './prepareSingleInOneGroupCheckboxGroupItemChangeModel';
export var prepareCheckboxGroupItemChangeModelFactory = function prepareCheckboxGroupItemChangeModelFactory(behavior) {
  return function (nestedCheckboxesService, values, checkboxGroupItem) {
    switch (behavior) {
      case EBehavior.Multiply:
        return prepareMultiplyCheckboxGroupItemChangeModel(nestedCheckboxesService, values, checkboxGroupItem);

      case EBehavior.SingleInOneGroup:
        return prepareSingleInOneGroupCheckboxGroupItemChangeModel(nestedCheckboxesService, values, checkboxGroupItem);

      case EBehavior.Single:
        return prepareSingleCheckboxGroupItemChangeModel(nestedCheckboxesService, checkboxGroupItem);
    }
  };
};